import { useEffect, createContext } from 'react'
import { auth } from '../firebase'
import { useLocalStorage } from 'react-use'

export const UserContext = createContext()

export const UserProvider = ({ children }) => {

  const [user, setUser, removeUser] = useLocalStorage('su-user')

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {

      setUser(user)

      // no user keep localstorage clear
      if (!user) removeUser()
    })

    return () => unsubscribe()
  }, [])

  return (
    <UserContext.Provider value={{user}}>
      {children}
    </UserContext.Provider>
  )
}